import { Button, IconButton, Typography } from "@mui/material";
import React, { FC, ReactNode } from "react";

type ChoiceCardProps = {
  icon: ReactNode;
  label: string;
  description: string;
  onClick: () => void;
};

export const ChoiceCard: FC<ChoiceCardProps> = ({
  icon,
  label,
  description,
  onClick,
}) => (
  <Button
    onClick={onClick}
    variant="outlined"
    fullWidth
    color="inherit"
    className="flex items-center justify-start gap-4 px-8 py-4"
  >
    <IconButton component="span" disableFocusRipple disableRipple>
      {icon}
    </IconButton>
    <span className="flex flex-col gap-0.5 items-start">
      <Typography>{label}</Typography>
      <Typography variant="body2" color="textSecondary" className="normal-case">
        {description}
      </Typography>
    </span>
  </Button>
);
